import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RemoteSignUpUpdate} from 'data/usecases';
import {SignUpUpdate} from 'domain/usecases';

import {EntryFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeSignUpUpdate = (): SignUpUpdate =>
	new RemoteSignUpUpdate(
		makeBFFApiUrl(EntryFlowEndPoints.signUpUpdate),
		makeAuthorizeHttpClientDecorator(),
	);
